import { i18n } from '@lingui/core';
import { isNil } from 'lodash-es';

export const formatNumber = (input: string | number, decimals = 6, minDecimals?: number) => {
  const numberToFormat = Number(input);

  if (!isNil(minDecimals) && minDecimals > decimals) {
    throw new Error('minDecimals can not be larger than decimals');
  }

  return new Intl.NumberFormat(i18n.locale, {
    minimumFractionDigits: minDecimals ?? decimals,
    maximumFractionDigits: decimals,
  }).format(numberToFormat);
};

export const formatPercent = (input: string | number, decimals = 6) => {
  const numberToFormat = Number(input);
  return formatNumber(numberToFormat * 100, decimals);
};
